import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import request from '../utils/request';

// Async thunk to fetch vehicle types
export const fetchVehicleType =
  async (productId = '') => {
    if (!productId) {
      throw new Error('productId is required');
    }
    const response = await request({
      url: 'vehichleType/getVehichleTypeListUsingProductId',
      method: 'post',
      data: {
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 2500,
        productId: productId,


      },
    });
    return response['vehichleTypeData'];
  }


// Async thunk to fetch machine types
export const fetchMachineType =
  async (productId = '') => {
    if (!productId) {
      throw new Error('productId is required');
    }
    const response = await request({
      url: 'machineType/getMachineTypeListUsingProductId',
      method: 'post',
      data: {
        machineTypeFilter: {
          search: null,
          orderColumn: 'id',
          orderDirection: 'DESC',
          offset: 0,
          limit: 250,
        },
        productId: productId,
      },
    });
    return response['machineTypeData'] ?? [];
  }


//  Async thunk to fetch asset types
export const fetchAssetType = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({
    url: 'assetType/getAssetTypeListUsingProductId',
    method: 'post',
    data: {
      assetTypeFilter: {
        search: null,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 250,
      },
      productId: productId,
    },
  });
  return response['assetTypeData'];
}

//  Async thunk to fetch asset types
export const fetchAgeRange = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({
    url: 'age/getAgeListByProductId/' + productId,
    method: 'post',
    data: {
      search: null,
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 2500,
      productId: productId
    }
  })
  return response['ageData'];
}

//  Async thunk to fetch occupancy
export const fetchOccupancy = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({
    url: 'occupancy/occupanyListAgainstProductId',
    method: 'post',
    data: {
      search: null,
      productId: productId,
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 10000000,
    },
  });
  return response['occupancyData'];
}

//  Async thunk to fetch occupancy
export const fetchOccupation = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({
    // url: 'occupancy/occupanyListAgainstProductId',
    url: 'occupation/getOccupationListByProductId/' + productId,
    method: 'post',
    data: {
      search: '',
      productId: productId,
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 10000000
    }
  });
  return response['occupationData'];
}

//  Async thunk to fetch occupancy
export const fetchProductRate = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({
    url: 'productRate/getProductRateListByProductId/' + productId,
    method: 'post',
    data: {
      search: null,
      productId: productId,
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 10000000
    }
  });
  return response['productRateData'];
}

//  Async thunk to fetch other settings
export const fetchOtherSettings = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({

    url: 'others-settings/getOthersSettingsListByProductId/' + productId,
    method: 'post',
    data: {
      search: null,
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 2500,
      productId: productId
    }
  });
  return response['othersSettingsData'];
}

//  Async thunk to fetch voyage data
export const fetchVoyageData = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({
    // url: 'occupancy/occupanyListAgainstProductId',
    url: 'voyage/getVoyageList',
    method: 'post',
    data: {
      search: '',
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 5000,
      productId
    }
  });
  return response['voyageData'];
}


//  Async thunk to fetch section master data
export const fetchSectionmaster = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({
    // url: 'occupancy/occupanyListAgainstProductId',
    url: 'section/getSectionListByProductId/' + productId,
    method: 'post',
    data: {
      search: null,
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 2500,
      productId: productId
    }
  });
  return response['sectionData'];
}

//  Async thunk to fetch cubic capacity master data
export const fetchCubicCapacitymaster = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({
    // url: 'occupancy/occupanyListAgainstProductId',
    url: 'CubicCapacity/getCubicCapacityList',
    method: 'post',
    data: {
      search: null,
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 2500,
      productId: productId
    }
  });
  return response['data'];
}

//  Async thunk to fetch project Type master data
export const fetchProjectTypeMaster = async (productId = '') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({

    url: 'projectType/getProjectTypeList',
    method: 'post',
    data: {
      search: null,
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 2500,
      productId: productId
    }
  });
  return response['projectTypeData'];
}

//  Async thunk to fetch common risk factor master data
export const fetchRiskfactorMaster = async (productId = '', apiUrl = null,riskFactorname='',method='POST') => {
  if (!productId) {
    throw new Error('productId is required');
  }
  const response = await request({

    url: apiUrl,
    method: method,
    data: {
      search: null,
      orderColumn: 'id',
      orderDirection: 'DESC',
      offset: 0,
      limit: 2500,
      productId: productId,
      status:true,
      riskFactor:riskFactorname
    }
  });


  let responseKey = '';  
  if (riskFactorname == 'Description') {
    responseKey = 'descriptionData';   
  } else if (riskFactorname == 'boilerType') {
    responseKey = 'boilerTypeData';   
  } else if (riskFactorname == 'Type') {
    responseKey = 'typeData';   
  } else if (riskFactorname == 'IndemnityPeriod') {
    responseKey = 'data';   
  } else if (riskFactorname == 'Age') {
    responseKey = 'data';   
  } else if (riskFactorname == 'StipulatedAge') {
    responseKey = 'data';   
  }else{
    responseKey = 'data';   

  }

  if(riskFactorname == 'vehicleMake'){    
   
      return response['data']['data'];
  
  }else{
    if (responseKey) {  
   
      return response[responseKey];
    }
  }

   

  
  
}

export const fetchLocationFromMaster = async (customerID = '', apiUrl = null,customerType) => {
  if (!customerID) {
    throw new Error('Customer is required');
  }
  const response = await request({

    url: apiUrl,
    method: 'post',
    data: {   
      customerId: customerID,
      customerType:customerType
    }
  });

    return response['data'];
  
  
}

export const fetchVehicleModel = async (makeId = '', apiUrl = null) => {
  if (!makeId) {
    throw new Error('Vehicle make id is required');
  }
  const response = await request({

    url: apiUrl,
    method: 'post',
    data: {   
      vehicleMakeId: makeId,
      limit:500,
      offset:0,
      orderDirection:'DESC'
    }
  });

    return response['data']['data'];
  
  
}

export const fetchVehicleVariant = async (modelId = '', apiUrl = null) => {
  if (!modelId) {
    throw new Error('Vehicle model id is required');
  }
  const response = await request({

    url: apiUrl,
    method: 'post',
    data: {   
      vehicleModelId: modelId,
      limit:500,
      offset:0,
      orderDirection:'DESC'
    }
  });

    return response['data']['data'];
  
  
}


const staticDataSlice = createSlice({
  name: 'staticData',
  initialState: {
    vehicleType: {
      data: [],
      status: 'idle',
      error: null,
    },
    machineType: {
      data: [],
      status: 'idle',
      error: null,
    },
    assetType: {
      data: [],
      status: 'idle',
      error: null,
    },
    ageRange: {
      data: [],
      status: 'idle',
      error: null,
    },
    occupancy: {
      data: [],
      status: 'idle',
      error: null,
    },
    occupation: {
      data: [],
      status: 'idle',
      error: null,
    },
    productRate: {
      data: [],
      status: 'idle',
      error: null,
    },
    othersSettings: {
      data: [],
      status: 'idle',
      error: null,
    },
    voyage: {
      data: [],
      status: 'idle',
      error: null,
    },
    sectionMaster: {
      data: [],
      status: 'idle',
      error: null,
    },
    cubicCapacity: {
      data: [],
      status: 'idle',
      error: null,
    },
    projectType: {
      data: [],
      status: 'idle',
      error: null,
    },
    description: {
      data: [],
      status: 'idle',
      error: null,
    },
    age: {
      data: [],
      status: 'idle',
      error: null,
    },
    boilerType: {
      data: [],
      status: 'idle',
      error: null,
    },
    type: {
      data: [],
      status: 'idle',
      error: null,
    },
    indemnityPeriod: {
      data: [],
      status: 'idle',
      error: null,
    },
    stipulatedAge: {
      data: [],
      status: 'idle',
      error: null,
    },
    testingPeriod: {
      data: [],
      status: 'idle',
      error: null,
    },
    territory: {
      data: [],
      status: 'idle',
      error: null,
    },
    jurisdiction: {
      data: [],
      status: 'idle',
      error: null,
    },
    basisOfValuation: {
      data: [],
      status: 'idle',
      error: null,
    },
    riskCovered: {
      data: [],
      status: 'idle',
      error: null,
    },
    modeOfTransit: {
      data: [],
      status: 'idle',
      error: null,
    },
    conveyance: {
      data: [],
      status: 'idle',
      error: null,
    },
    projectPeriod: {
      data: [],
      status: 'idle',
      error: null,
    },
    vehicleMake: {
      data: [],
      status: 'idle',
      error: null,
    },
    packingRf: {
      data: [],
      status: 'idle',
      error: null,
    },
    location: {
      data: [],
      status: 'idle',
      error: null,
    },
    vehicleModel: {
      data: [],
      status: 'idle',
      error: null,
    },
    vehicleVariant:{
      data: [],
      status: 'idle',
      error: null,
    }

  },
  reducers: {
    // Reducer to handle pending state
    setLoading: (state, action) => {
      const { dataType } = action.payload; 
      state[dataType].status = 'loading';
    },
    // Reducer to handle fulfilled state
    setDataSuccess: (state, action) => {
      const { dataType, data } = action.payload; 
      state[dataType].status = 'success';
      state[dataType].data = data;
      state[dataType].error = null;

    },
    // Reducer to handle rejected state
    setDataError: (state, action) => {
      const { dataType, error } = action.payload;
      state[dataType].status = 'failed';
      state[dataType].error = error;
    },
  },
});

export const { setLoading, setDataSuccess, setDataError } = staticDataSlice.actions;

// Selectors for vehicleType, machineType, and assetType
export const selectVehicleType = (state) => state.staticList.vehicleType.data;
export const selectMachineType = (state) => state.staticList.machineType.data;
export const selectAssetType = (state) => state.staticList.assetType.data;
export const selectAgeRange = (state) => state.staticList.ageRange.data;
export const selectOccupancy = (state) => state.staticList.occupancy.data;
export const selectOccupation = (state) => state.staticList.occupation.data;
export const selectProductRate = (state) => state.staticList.productRate.data;
export const selectOtherSettings = (state) => state.staticList.othersSettings.data;
export const selectVoyage = (state) => state.staticList.voyage.data;
export const selectSectionmaster = (state) => state.staticList.sectionMaster.data;
export const selectCubicCapacity = (state) => state.staticList.cubicCapacity.data;
export const selectProjectType = (state) => state.staticList.projectType.data;
export const selectAge = (state) => state.staticList.age.data;
export const selectDescription = (state) => state.staticList.description.data;
export const selectBoilerType = (state) => state.staticList.boilerType.data;
export const selectType = (state) => state.staticList.type.data;
export const selectIndemnityPeriod = (state) => state.staticList.indemnityPeriod.data;
export const selectStipulatedAge = (state) => state.staticList.stipulatedAge.data;
export const SelectVehicleMake = (state) => state.staticList.vehicleMake.data;
export const selectTestingPeriod = (state) => state.staticList.testingPeriod.data;
export const selectSTerritory = (state) => state.staticList.territory.data;
export const selectJurisdiction = (state) => state.staticList.jurisdiction.data;
export const selectBasisOfValuation = (state) => state.staticList.basisOfValuation.data;
export const selectRiskCovered = (state) => state.staticList.riskCovered.data;
export const selectModeOfTransit = (state) => state.staticList.modeOfTransit.data;
export const selectConveyance = (state) => state.staticList.conveyance.data;
export const selectProjectPeriod = (state) => state.staticList.projectPeriod.data;
export const selectPackingRf = (state) => state.staticList.packingRf.data;
export const selectLocationFromMaster = (state) => state.staticList.location.data;
export const selectVehicleModel = (state) => state.staticList.vehicleModel.data;
export const selectVehicleVariant = (state) => state.staticList.vehicleVariant.data;



export const selectVehicleTypeStatus = (state) => state.staticList.vehicleType.status;
export const selectMachineTypeStatus = (state) => state.staticList.machineType.status;
export const selectAssetTypeStatus = (state) => state.staticList.assetType.status;
export const selectAgeRangeStatus = (state) => state.staticList.ageRange.status;
export const selectOccupancyStatus = (state) => state.staticList.occupancy.status;
export const selectOccupationStatus = (state) => state.staticList.occupation.status;
export const selectProductRateStatus = (state) => state.staticList.productRate.status;
export const selectOtherSettingsStatus = (state) => state.staticList.othersSettings.status;
export const selectVoyageStatus = (state) => state.staticList.voyage.status;
export const selectSectionmasterStatus = (state) => state.staticList.sectionMaster.status;
export const selectCubicCapacityStatus = (state) => state.staticList.cubicCapacity.status;
export const selectProjectTypeStatus = (state) => state.staticList.projectType.status;
export const selectAgeStatus = (state) => state.staticList.age.status;
export const selectDescriptionStatus = (state) => state.staticList.description.status;
export const selectBoilerTypeStatus = (state) => state.staticList.boilerType.status;
export const selectTypeStatus = (state) => state.staticList.type.status;
export const selectIndemnityPeriodStatus = (state) => state.staticList.indemnityPeriod.status;
export const selectStipulatedAgeStatus = (state) => state.staticList.stipulatedAge.status;
export const SelectVehicleMakeStatus = (state) => state.staticList.vehicleMake.status;
export const selectTestingPeriodStatus = (state) => state.staticList.testingPeriod.status;
export const selectSTerritoryStatus = (state) => state.staticList.territory.status;
export const selectJurisdictionStatus = (state) => state.staticList.jurisdiction.status;
export const selectBasisOfValuationStatus = (state) => state.staticList.basisOfValuation.status;
export const selectRiskCoveredStatus = (state) => state.staticList.riskCovered.status;
export const selectModeOfTransitStatus = (state) => state.staticList.modeOfTransit.status;
export const selectConveyanceStatus = (state) => state.staticList.conveyance.status;
export const selectProjectPeriodStatus = (state) => state.staticList.projectPeriod.status;
export const selectPackingRfStatus = (state) => state.staticList.packingRf.status;
export const selectLocationFromMasterStatus = (state) => state.staticList.location.status;
export const selectVehicleModelStatus = (state) => state.staticList.vehicleModel.status;
export const selectVehicleVariantStatus = (state) => state.staticList.vehicleVariant.status;

export const selectVehicleTypeError = (state) => state.staticList.vehicleType.error;
export const selectMachineTypeError = (state) => state.staticList.machineType.error;
export const selectAssetTypeError = (state) => state.staticList.assetType.error;
export const selectAgeRangeError = (state) => state.staticList.ageRange.error;
export const selectOccupancyError = (state) => state.staticList.occupancy.error;
export const selectOccupationError = (state) => state.staticList.occupation.error;
export const selectProductRateError = (state) => state.staticList.productRate.error;
export const selectOtherSettingsError = (state) => state.staticList.othersSettings.error;
export const selectVoyageStatusError = (state) => state.staticList.voyage.error;
export const selectSectionmasterError = (state) => state.staticList.sectionMaster.error;
export const selectCubicCapacityError = (state) => state.staticList.cubicCapacity.error;
export const selectProjectTypeError = (state) => state.staticList.projectType.error;
export const selectAgeError = (state) => state.staticList.age.error;
export const selectDescriptionSError = (state) => state.staticList.description.error;
export const selectBoilerTypeError = (state) => state.staticList.boilerType.error;
export const selectTypeError = (state) => state.staticList.type.error;
export const selectIndemnityPeriodError = (state) => state.staticList.indemnityPeriod.error;
export const selectStipulatedAgeError = (state) => state.staticList.stipulatedAge.error;
export const SelectVehicleMakeError = (state) => state.staticList.vehicleMake.error;
export const selectTestingPeriodError = (state) => state.staticList.testingPeriod.error;
export const selectSTerritoryError = (state) => state.staticList.territory.error;
export const selectJurisdictionError = (state) => state.staticList.jurisdiction.error;
export const selectBasisOfValuationError = (state) => state.staticList.basisOfValuation.error;
export const selectRiskCoveredError = (state) => state.staticList.riskCovered.error;
export const selectModeOfTransitError = (state) => state.staticList.modeOfTransit.error;
export const selectConveyanceError = (state) => state.staticList.conveyance.error;
export const selectProjectPeriodError = (state) => state.staticList.projectPeriod.error;
export const selectPackingRfError = (state) => state.staticList.packingRf.error;
export const selectLocationFromMasterError = (state) => state.staticList.location.error;
export const selectVehicleModelError = (state) => state.staticList.vehicleModel.error;
export const selectVehicleVariantError = (state) => state.staticList.vehicleVariant.error;

export default staticDataSlice.reducer;
